import { render, staticRenderFns } from "./HomeBasicInfo.vue?vue&type=template&id=48804ed5&scoped=true"
import script from "./HomeBasicInfo.vue?vue&type=script&lang=ts"
export * from "./HomeBasicInfo.vue?vue&type=script&lang=ts"
import style0 from "./HomeBasicInfo.vue?vue&type=style&index=0&id=48804ed5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48804ed5",
  null
  
)

export default component.exports